import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from '../components';
import { LightboxComponent } from './lightbox.component';
import { LightboxDirective } from './lightbox.directive';
import { LightboxService } from './lightbox.service';

@NgModule({
  imports: [
    CommonModule,
    IconModule
  ],
  providers: [
    LightboxService
  ],
  declarations: [
    LightboxDirective,
    LightboxComponent
  ],
  exports: [
    LightboxDirective
  ]
})
export class LightboxModule {
}
